<script setup lang="ts">
import { useI18n } from '@/shared/i18n'
import { Button } from '@/shared/ui/button'
import { Spinner } from '@/shared/ui/spinner'
import { Textarea } from '@/shared/ui/textarea'

defineProps<{
  disabled: boolean
  sending: boolean
  remainingTurns: number
  errorMessage: string | undefined
}>()
const message = defineModel<string>({ required: true })
const emit = defineEmits<{ send: [] }>()
const { t } = useI18n()
</script>

<template>
  <form
    class="authoring-composer grid gap-sm"
    data-testid="authoring-composer"
    @submit.prevent="emit('send')"
  >
    <Textarea
      v-model="message"
      :label="t('insights.sysadmin.authoring.composer.label')"
      :placeholder="t('insights.sysadmin.authoring.composer.placeholder')"
      :disabled="disabled"
      :error="Boolean(errorMessage)"
      :error-message="errorMessage || ''"
      :rows="4"
      auto-grow
    />
    <div
      class="authoring-composer__footer flex items-center justify-end gap-md text-muted text-[0.8125rem]"
    >
      <span>{{
        t('insights.sysadmin.authoring.composer.remaining', { count: remainingTurns })
      }}</span>
      <Spinner v-if="sending" size="sm">
        {{ t('insights.sysadmin.authoring.progress.sending') }}
      </Spinner>
      <Button type="submit" :disabled="disabled || !message.trim()" :loading="sending">
        {{ t('insights.sysadmin.authoring.composer.send') }}
      </Button>
    </div>
  </form>
</template>
